/**
 * Mapeia a unidade do Painel de Monitoramento de PS (base + empresa do MV)
 * para o ID de local da Insightcare usado no Painel de Probabilidade de Internação.
 */
const LOCAIS_PROBABILIDADE_INTERNACAO = {
	'db-orcl-hsl': {
		1: 1,    // HSLS - Hospital Santa Lúcia Sul
		3: 111,  // HSLG - Hospital Santa Lúcia Gama
		4: 77,   // HSLN - Hospital Santa Lúcia Norte
		9: 365,  // HSLT - Unidade Avançada Taguatinga
	},
	'db-orcl-hsr': {
		1: 295,  // HSR - Hospital Santa Rosa
		10: 561, // HO - Hospital Ortopédico
		11: 711, // UAVG - Unidade Avançada Várzea Grande
	},
	'db-orcl-hcms': {
		1: 639,  // HCMS
	},
	'db-orcl-hslb': {
		1: 768,  // HSLB - Bauru
	},
};

/**
 * Monta a URL do Painel de Probabilidade de Internação da mesma unidade
 * apresentada no Painel de Monitoramento de PS.
 * Retorna null quando a unidade não possui local mapeado na Insightcare.
 */
export const getUrlProbabilidadeInternacao = (base, company) => {
	const idLocal = LOCAIS_PROBABILIDADE_INTERNACAO[base]?.[Number(company)];

	return idLocal ? `/painel/ps-probabilidade-internacao/${idLocal}` : null;
};
